import { Link, Button, Header } from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import { useRegistrationPolicies } from "@pbm/registration-policies/hooks";
import { IRegistrationPolicy } from "@pbm/registration-policies/contracts";
import { useMemo } from "react";
import { Column } from "react-table";
import { useHistory } from "react-router-dom";
import { IntlDateTime } from "@funcional/react-intl-ui";
import { GridView } from "@funcional/react-table-ui";

interface CellProps {
  value: any;
  row: { original: IRegistrationPolicy };
}

export default function ListRegistrationPolicyPage() {
  const history = useHistory();

  const editRecord = (row: any) =>
    history.push(`/pbm/registration-policies/${row.original.id}/edit`);

  const showRecord = (row: any) =>
    history.push(`/pbm/registration-policies/${row.original.id}`);

  const columns: Column<IRegistrationPolicy>[] = useMemo(
    () => [
      {
        Header: "Política Cadastral",
        accessor: "description",
        Cell: ({ row: { original } }: CellProps) => (
          <Link to={`/pbm/registration-policies/${original?.id}`}>
            {original.description}
          </Link>
        ),
      },
      {
        Header: "Exige cadastro?",
        accessor: "requiresRegistration",
        Cell: ({ value }: CellProps) => (value ? "Sim" : "Não"),
      },
      {
        Header: "Exige receita?",
        accessor: "requiresPrescription",
        Cell: ({ value }: CellProps) => (value ? "Sim" : "Não"),
      },
      {
        Header: "Exige Contato?",
        accessor: "requiresContactInformation",
        Cell: ({ value }: CellProps) => (value ? "Sim" : "Não"),
      },
      {
        Header: "Exige Api Externa?",
        accessor: "enabledApiExternal",
        Cell: ({ value }: CellProps) => (value ? "Sim" : "Não"),
      },
      {
        Header: "Data",
        accessor: "createdAt",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
    ],
    []
  );

  return (
    <>
      <Header
        title="Políticas Cadastrais"
        buttons={
          <Restricted to="create.registration-policies">
            <Button color="primary" href="/pbm/registration-policies/new">
              Nova
            </Button>
          </Restricted>
        }
      />

      <GridView<IRegistrationPolicy>
        accessControlResourceName={"registration-policies"}
        editRecord={editRecord}
        showRecord={showRecord}
        columns={columns}
        hook={useRegistrationPolicies}
      />
    </>
  );
}
